module.exports = __webpack_public_path__ + "static/media/career-vision.6c572692.png";